module.exports = __webpack_public_path__ + "img/entry-hero.6ca2ff17.png";